import common from './general/common.json';
import messages from './general/messages.json';
import error from './general/error.json';
import pageClose from './general/page-close.json';
import auth from './auth/login.json';
import adultPatientAssessment from './medcards/adult-patient-assessment.json';
import adverseEffectForm from './medcards/adverse-effect-form.json';
import apacheiiScore from './medcards/apacheii-score.json';
import basiBraden from './medcards/basi-braden.json';
import bloodSugarTrace from './medcards/blood-sugar-trace.json';
import bloodTransfusion from './medcards/blood-transfusion.json';
import canScale from './medcards/can-scale.json';
import catheterMaterialTracking from './medcards/catheter-material-tracking.json';
import childPatientAssessment from './medcards/child-patient-assessment.json';
import cirrhosisViolance from './medcards/cirrhosis-violance.json';
import cribScore from './medcards/crib-score.json';
import emaSepsis from './medcards/ema-sepsis.json';
import fallRiskItaki from './medcards/fall-risk-itaki.json';
import fallRiskHarizmi from './medcards/fall-risk-harizmi.json';
import glasgow from './medcards/glasgow.json';
import euroScore from './medcards/euro-score.json';
import capriniRiskAssessment from './medcards/caprini-risk-assessment.json';
import card from './medcards/card.json';
import generalHealth from './medcards/general-health.json';
import heightWeight from './medcards/height-weight.json';
import improveBleedingRisk from './medcards/improve-bleeding-risk.json';
import improveVteRiskAssessment from './medcards/improve-vte-risk-assessment.json';
import motherFallRiskAssessment from './medcards/mother-fall-risk-assessment.json';
import neomod from './medcards/neomod.json';
import newbornNutrition from './medcards/newborn-nutrition.json';
import newbornPatientAssessment from './medcards/newborn-patient-assessment.json';
import newbornSkinRiskAssessment from './medcards/newborn-skin-risk-assessment.json';
import newbornFollow from './medcards/newborn-follow.json';
import northomtonScore from './medcards/northomton-score.json';
import nutritionalRiskScore from './medcards/nutritional-risk-score.json';
import partografForm from './medcards/partograf-form.json';
import pediatricAssessment from './medcards/pediatric-assessment.json';
import pediatricTraumaScore from './medcards/pediatric-trauma-score.json';
import pregnancyVenous from './medcards/pregnancy-venous.json';
import prismScore from './medcards/prism-score.json';
import revisedTraumaScore from './medcards/revised-trauma-score.json';
import vteRiskFaktorEvaluation from './medcards/vte-risk-faktor-evaluation.json';
import vteRiskFactorEvaluationCard from './medcards/vte-risk-factor-evaluation-card.json';
import safeBirthControlForm from './medcards/safe-birth-control-form.json';
import saps2Score from './medcards/saps2-score.json';
import snap2Score from './medcards/snap2-score.json';
import strongKids from './medcards/strong-kids.json';
import tollnerSepsis from './medcards/tollner-sepsis.json';
import waterlowScore from './medcards/waterlow-score.json';
import woundAssess from './medcards/wound-assess.json';
import buttons from './components/buttons.json';
import menus from './components/menus.json';
import names from './components/names.json';
import openedMedcards from './components/opened-medcards.json';
import patientdata from './components/patient-data.json';
import print from './components/print.json';
import dietRequestsDoctor from './pages/diet-requests-doctor.json'
import dietRequestsRefectory from './pages/diet-requests-refectory.json'
import isolationRequests from './pages/isolation-requests.json'
import nurse from './pages/nurse.json'
import nurseSurgeryProcedure from './pages/nurse-surgery-procedure.json'
import nurseExamination from './pages/nurse-examination.json'
import patientCareGuide from './pages/patient-care-guide.json'
import patientCareHistory from './pages/patient-care-history.json'
import patientCare from './pages/patient-care.json'
import patientDietHistory from './pages/patient-diet-history.json'
import patientDietProcedures from './pages/patient-diet-procedures.json'
import vitalSigns from './medcards/vital-signs.json'
import ration from './pages/ration.json'
import surgeryProcedure from './pages/surgery-procedure.json'
import patientRequestService from './pages/patient-request-service.json'
import casus from './medcards/casus.json';
import modifiedAldrete from './medcards/modified-aldrete.json';
import acuteGHVDClinicalScoring from './medcards/acute-ghvd-clinical-scoring.json';
import edinburghDeptScale from './medcards/edineburgh-dept-scale.json';
import sofaScore from './medcards/sofa-score.json';
import painAssessmentScale from './medcards/pain-assessment-scale.json';
import patientMonitoring from './medcards/patient-monitoring.json';
import patientProcess from './pages/patient-process.json';
import requestList from './pages/request-list.json';
import patientAiAnalysis from './pages/patient-ai-analysis.json';

const
  translations = {
    ...common,
    ...messages,
    ...error,
    ...pageClose,
    ...auth,
    ...adultPatientAssessment,
    ...adverseEffectForm,
    ...apacheiiScore,
    ...basiBraden,
    ...bloodSugarTrace,
    ...bloodTransfusion,
    ...canScale,
    ...catheterMaterialTracking,
    ...childPatientAssessment,
    ...cirrhosisViolance,
    ...cribScore,
    ...emaSepsis,
    ...fallRiskItaki,
    ...fallRiskHarizmi,
    ...glasgow,
    ...euroScore,
    ...capriniRiskAssessment,
    ...card,
    ...generalHealth,
    ...heightWeight,
    ...improveBleedingRisk,
    ...improveVteRiskAssessment,
    ...motherFallRiskAssessment,
    ...neomod,
    ...newbornNutrition,
    ...newbornPatientAssessment,
    ...newbornSkinRiskAssessment,
    ...newbornFollow,
    ...northomtonScore,
    ...nutritionalRiskScore,
    ...partografForm,
    ...pediatricAssessment,
    ...pediatricTraumaScore,
    ...pregnancyVenous,
    ...prismScore,
    ...revisedTraumaScore,
    ...vteRiskFaktorEvaluation,
    ...vteRiskFactorEvaluationCard,
    ...safeBirthControlForm,
    ...saps2Score,
    ...snap2Score,
    ...strongKids,
    ...tollnerSepsis,
    ...waterlowScore,
    ...woundAssess,
    ...buttons,
    ...menus,
    ...names,
    ...openedMedcards,
    ...patientdata,
    ...print,
    ...dietRequestsDoctor,
    ...dietRequestsRefectory,
    ...isolationRequests,
    ...nurse,
    ...nurseSurgeryProcedure,
    ...nurseExamination,
    ...patientCareGuide,
    ...patientCareHistory,
    ...patientCare,
    ...patientDietHistory,
    ...patientDietProcedures,
    ...vitalSigns,
    ...ration,
    ...surgeryProcedure,
    ...patientRequestService,
    ...casus,
    ...modifiedAldrete,
    ...acuteGHVDClinicalScoring,
    ...edinburghDeptScale,
    ...sofaScore,
    ...painAssessmentScale,
    ...patientMonitoring,
    ...patientProcess,
    ...requestList,
    ...patientAiAnalysis
  };

export default translations;
